import styled from 'styled-components';
var vertical = {
  top: 'flex-start',
  middle: 'middle',
  bottom: 'flex-end'
};
export var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-w1c2vg-0"
})(["display:flex;flex-direction:column;flex-grow:1;justify-content:", ";height:100%;padding:16px;background-color:", ";color:", ";"], function (props) {
  return vertical[props.verticalAlign] || 'middle';
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.color;
});